import _defineProperty from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import ReactPlayer from 'react-player';
import { maxBlockWidth } from '../../../utils/post.constants';
import { jsx as _jsx } from "react/jsx-runtime";
export var AudioPlayer = function AudioPlayer(_ref) {
  var src = _ref.src,
      attributes = _ref.attributes,
      className = _ref.className;
  return /*#__PURE__*/_jsx("div", _objectSpread(_objectSpread({}, attributes), {}, {
    contentEditable: false,
    className: className,
    children: /*#__PURE__*/_jsx(ReactPlayer, {
      url: src,
      width: maxBlockWidth,
      height: "auto",
      controls: true,
      contentEditable: false,
      style: {
        userSelect: 'none',
        maxWidth: '100%',
        display: 'block'
      },
      config: {
        file: {
          attributes: {
            width: '100%',
            style: {
              minHeight: 40,
              width: '100%',
              display: 'block'
            }
          }
        }
      }
    })
  }));
};